<template>
    <v-row align="center">
        <v-col>
            <v-select v-model="form.educationLevel.items" :items="educationLevels" :disabled="form.educationLevel.isIrrelevant" multiple outlined attach @input="emit" />
        </v-col>
        <v-col cols="auto">
            <v-switch v-model="form.educationLevel.isIrrelevant" label="학력무관" dense inset hide-details @change="onChangeIsIrrelevant" />
        </v-col>
        <v-col cols="auto">
            <v-checkbox v-model="form.educationLevel.includesToBe" label="졸업예정자 가능" :disabled="form.educationLevel.isIrrelevant" hide-details @change="emit" />
        </v-col>
    </v-row>
</template>

<script>
import { EDUCATION_LEVELS, initRecruitmentField__qualification } from "@/assets/variables";

const educationLevels = Object.values(EDUCATION_LEVELS);

export default {
    props: {
        value: { type: Object, default: initRecruitmentField__qualification },
    },
    data: () => ({
        form: initRecruitmentField__qualification(),
        educationLevels,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitmentField__qualification(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        onChangeIsIrrelevant() {
            this.form.educationLevel.items = [];
            this.form.educationLevel.includesToBe = false;
            this.emit();
        },
    },
};
</script>

<style>
</style>